import React from "react";
import PropTypes from "prop-types";
import "./Paragraph.scss";

export const Paragraph = ({
  size = "default",
  text,
  tight = false,
  noMargin = false,
  ...props
}) => {
  return (
    <p
      {...props}
      className={`ha-paragraph ${props.className} ${size} ${size}-${
        tight ? "tight" : "loose"
      } ${noMargin && "no-margin"}`}
    >
      {props.children || text}
    </p>
  );
};

Paragraph.propTypes = {
  size: PropTypes.oneOf([
    "default",
    "body-short-02",
    "small",
    "caption",
    "cap-12",
    "cap-14",
    "cap-18",
  ]),
  tight: PropTypes.bool,
  noMargin: PropTypes.bool,
  text: PropTypes.string,
};

